import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'template']

  connect() {
    this.page = 1
    this.reset()
  }

  reset() {
    this.containerWidth = this.element.offsetWidth - 42
    this.categoriesCount = Math.floor(this.containerWidth / 140)
    if (this.categoriesCount > 4) {
      this.categoriesCount -= 1
    }
    if (this.containerTarget.children.length < 1) {
      this.getCategories()
    }
  }

  next() {
    this.page += 1
    if (!this.getCategories()) {
      this.page -= 1
    }
  }

  prev() {
    this.page -= 1
    if (this.page < 1) {
      this.page = 1
    }
    this.getCategories()
  }

  getCategories() {
    let nodes = this.templateTarget.content.cloneNode(true)
    let startIndex = ((this.page - 1) * this.categoriesCount)
    let cleared = false
    let result = true
    for (let i = 0; i < this.categoriesCount; i++) {
      let node = nodes.children[startIndex]
      if (node) {
        if (!cleared) {
          this.containerTarget.innerHTML = ''
          cleared = true
        }
        this.containerTarget.append(node)
      } else {
        result = false
      }
    }
    window.activatePushedContent?.(this.element)
    return result
  }
}
